export const SHOW_LOADING = 'SHOW_LOADING'
export const ORGANIZATION_LIST_SUCCESS = 'ORGANIZATION_LIST_SUCCESS'
export const ORGANIZATION_FAIL = 'ORGANIZATION_FAIL'
export const CREATE_NEW_ORGANIZATION = 'CREATE_NEW_ORGANIZATION'
export const SET_ORGANIZATION = 'SET_ORGANIZATION'
export const RESET_ORGANISATION= 'RESET_ORGANISATION'
